import axios, { AxiosResponse } from 'axios';
import { CreateTemporaryPlanningProfileInput } from '../../types/create-temporary-profile-input.type';

// POST
// Adds temporary profiles to fishgroup.
// /ewosapi/v1/planandprognosis/temporaryprofiles/{fishGroupId}
export const postTemporaryPlanningProfile = async (
  fishGroupId: string,
  request: CreateTemporaryPlanningProfileInput
): Promise<AxiosResponse> => {
  return await axios.post(`/ewosapi/v1/planandprognosis/temporaryprofiles/${fishGroupId}`, [request]);
};
